import { render, staticRenderFns } from "./TopicViewPage.vue?vue&type=template&id=f9d4371c&scoped=true&"
import script from "./TopicViewPage.vue?vue&type=script&lang=js&"
export * from "./TopicViewPage.vue?vue&type=script&lang=js&"
import style0 from "./TopicViewPage.vue?vue&type=style&index=0&id=f9d4371c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d4371c",
  null
  
)

export default component.exports